export default "__VITE_ASSET__469e7ecb__"